import BaseRequest from "@/utils/http/index";

let request = new BaseRequest("");

let prefix = "/api/patent";

//保存搜索记录
export const saveSearchRecord = params => {
  return request.post(
    prefix + "/patentSearch/saveHistoricalSearchRecord",
    params
  );
};

//查询搜索记录
export const querySearchHistory = params => {
  return request.post(
    prefix + "/patentSearch/getHistoricalSearchRecord",
    params
  );
};

// 埋点
export const clickRecord = (params) => {
  // return request.post(prefix + '/sourceadmin/clickRecord', params);
  return request.post('/api/source/sourceh5/clickRecord', params);
};

